<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center m-md-5 m-3 p-xs-2">
        <b-col xs="10" sm="9" md="8">
          <b-card class="p-1 p-md-5">
            <h2>Preservetime</h2>
            <div class="mt-3">
              <b-spinner variant="primary" small></b-spinner>
              <p class="ml-2" style="display: inline-block">
                Signing into Preservetime...
              </p>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import auth from "../../shared/auth";
import router from "../../router";
import { userService } from "../../shared/services";

export default {
  created: function() {
    this.$nextTick(() => {
      auth.setAccessToken();
      const token = auth.getAccessToken();
      userService.loginExternal(token).finally(() => {
        router.push("/");
      });
    });
  }
};
</script>
